import { defineStore } from 'pinia';

import type { DeductionReason } from '@stuut/api/models';

import { stuut } from '@/api';

interface State {
  initLoad: boolean;
  reasons: DeductionReason[];
}

export const useDeductionReasonStore = defineStore('deductionReasons', {
  actions: {
    async setup() {
      if (this.reasons?.length || this.initLoad) return;

      this.initLoad = true;

      const reasons = await stuut.deductionReasons.list();

      this.$patch({ reasons });

      return this.reasons;
    },
  },

  getters: {
    getById: (state) => {
      return (id: string) => state.reasons.find((reason) => reason?.id === id);
    },
  },

  state: (): State => ({
    initLoad: false,
    reasons: [],
  }),
});

export default useDeductionReasonStore;
